import { SpeakingLevel } from "../gql/graphql.ts";
import { SelectOption } from "@normasteaching/norma-ui";

export function getAllSpeakingClassLevelOptions(): SelectOption<SpeakingLevel>[] {
  return Object.values(SpeakingLevel).map((v) => ({
    name: v,
    id: v,
  }));
}
